export { AppComponent } from './components/app.component/app.component';
export { AppModule } from './app.module';



// WEBPACK FOOTER //
// /Users/sergeisidorov/Projects/streamViewer/src/app/index.ts